import React from "react";

const AlertModal = ({ message, onConfirm }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 ">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h3 className="text-lg font-medium mb-4">Session Alert</h3>
        <p className="mb-6">{message}</p>
        <div className="flex justify-end">
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-primary text-text1 rounded hover:bg-primary"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
